module.exports = __webpack_public_path__ + "img/star-empty.430c91a4.svg";